export default __webpack_public_path__ + "static/media/add-ping-button.5a84925d.png";